import { useContext, useState } from "react";
import { Type_dossier } from "shared/types/types";
import { UserContext } from "features/account";

export default function CreateDossierDialog({open, onClose, onCreate}:{open: boolean; onClose: () => void; onCreate: (t: Type_dossier, name?: string) => void;}){
    const [type, setType] = useState<Type_dossier>(Type_dossier.LOCATION_LOGEMENT);
    const [name, setName] = useState("");
    const { user, userType, isVerified, getMe } = useContext(UserContext);

    if(!open) return null;
    return (
        <div className="idk-modal">
            <div className="idk-modal_content">
                <h2 style={{fontSize:18, fontWeight:800, marginBottom:8}}>DOSSIER</h2>
                <p style={{fontSize:14, color:"#0c50beff", marginBottom:12}}>Veuillez choisir le type de dossier que vous voulez protéger</p>
                <label className="idk-label" style={{display:"block", fontSize:14, fontWeight:600, marginBottom:4}}>Type</label>
                <select className="idk-select" value={type} onChange={(e) => setType(e.target.value as Type_dossier)}>
                    <option value={Type_dossier.LOCATION_LOGEMENT}>Location de logement</option>
                    {/*<option value={Type_dossier.VEHICULE_OCCASION}>Véhicule d'occasion</option>*/}
                    <option value={Type_dossier.AUTRE}>Autre</option>
                </select>
                {type === Type_dossier.AUTRE && (
                    <div style={{marginTop:12}}>
                        <label className="idk-label" style={{display:"block", fontSize:14, fontWeight:600, marginBottom:4}}>Nom du dossier</label>
                        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Saisissez un nom..." className="idk-input"/>
                    </div>
                )}
                <div style={{display:"flex", justifyContent:"flex-end", gap:8, marginTop:16}}>
                    <button onClick={onClose} className="btn btn-outlined btn-primary">Annuler</button>
                    <button onClick={() => onCreate(type,name)} className={`btn ${userType === "partner" ? " btn-secondary" : "btn-primary"} btn-solid`}>Créer</button>
                </div>
            </div>
        </div>
    );
}